<template>
  <div>
    <h1>Talleres</h1>
    
    <!-- Campo de búsqueda -->
    <div style="margin-bottom: 1rem; display: flex; gap: 1rem; align-items: center;">
      <input 
        v-model="filtroDescripcion" 
        placeholder="Buscar por descripción del taller" 
        @input="buscarEnTiempoReal"
        style="padding: 0.5rem; width: 300px; border: 1px solid #ddd; border-radius: 4px;"
      />
      <button @click="aplicarFiltros" style="padding: 0.5rem 1rem; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">Buscar</button>
    </div>
    
    <div style="margin-bottom:1.5rem;">
      <button @click="abrirModalAgregar" 
              style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border: none; padding: 0.8rem 1.5rem; border-radius: 6px; font-size: 1rem; font-weight: 600; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.2); transition: transform 0.2s, box-shadow 0.2s;"
              @mouseover="$event.target.style.transform='translateY(-1px)'; $event.target.style.boxShadow='0 4px 8px rgba(0,0,0,0.3)'"
              @mouseleave="$event.target.style.transform='translateY(0)'; $event.target.style.boxShadow='0 2px 4px rgba(0,0,0,0.2)'">
        + Agregar Taller
      </button>
    </div>
    
    <!-- Contador de Total -->
    <div style="margin-bottom: 1rem; display: flex; justify-content: flex-end;">
      <div style="padding: 0.4rem 0.8rem; background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
        <span style="font-size: 0.85rem; font-weight: 600; color: #495057;">
          Total Talleres: {{ total }}
        </span>
      </div>
    </div>

    <div style="overflow-x: auto; box-shadow: 0 4px 12px rgba(0,0,0,0.1); border-radius: 12px; background: white;">
      <table style="width:100%; border-collapse:collapse; min-width: 800px;">
      <thead>
        <tr style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
          <th style="padding: 1rem; text-align: left; font-weight: 600; width: 80px; min-width: 60px;">ID</th>
          <th style="padding: 1rem; text-align: left; font-weight: 600; width: 250px; min-width: 200px;">Descripción</th>
          <th style="padding: 1rem; text-align: left; font-weight: 600; width: 180px; min-width: 150px;">Maestro</th>
          <th style="padding: 1rem; text-align: left; font-weight: 600; width: 400px; min-width: 350px;">Horarios por Día</th>
          <th style="padding: 1rem; text-align: center; font-weight: 600; width: 190px; min-width: 160px;">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="taller in talleres" :key="taller.id" style="border-bottom: 1px solid #e9ecef; transition: background-color 0.2s;" 
            @mouseover="$event.target.style.backgroundColor='#f8f9fa'" 
            @mouseleave="$event.target.style.backgroundColor='white'">
          <td style="padding: 1rem; font-weight: 600; color: #495057; width: 80px; text-align: center;">{{ taller.id }}</td>
          <td style="padding: 1rem; font-weight: 500; color: #212529; width: 250px;">{{ taller.descripcion }}</td>
          <td style="padding: 1rem; color: #6c757d; width: 180px;">{{ taller.nombreMaestro }}</td>
          <td style="padding: 0.8rem;">
            <div style="display: flex; flex-wrap: wrap; gap: 0.8rem;">
              <div v-for="(grupo, index) in taller.grupos" :key="grupo.idGrupo" 
                   style="background: #f8f9fa; border: 2px solid #007bff; border-radius: 8px; padding: 0.8rem; min-width: 200px;">
                <div style="font-weight: bold; color: #007bff; font-size: 0.9rem; margin-bottom: 0.5rem; text-align: center; border-bottom: 2px solid #007bff; padding-bottom: 0.3rem;">
                  Grupo {{ index + 1 }} (Max: {{ grupo.maxAlumnos }})
                </div>
                
                <div style="margin-bottom: 0.5rem;">
                  <strong style="font-size: 0.8rem; color: #495057;">Grados:</strong>
                  <div style="display: flex; flex-wrap: wrap; gap: 0.2rem; margin-top: 0.2rem;">
                    <span v-for="grado in grupo.grados" :key="grado.idGrado"
                          style="background: #28a745; color: white; border-radius: 3px; padding: 0.1rem 0.3rem; font-size: 0.7rem;">
                      {{ grado.grado }}
                    </span>
                  </div>
                </div>
                
                <div>
                  <strong style="font-size: 0.8rem; color: #495057;">Horarios:</strong>
                  <div v-for="(horariosDia, dia) in agruparHorariosPorDiaGrupo(grupo.horariosDias)" :key="dia" style="margin-top: 0.3rem;">
                    <div style="font-size: 0.75rem; color: #6c757d; font-weight: 600;">{{ dia }}:</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 0.2rem; margin-top: 0.1rem;">
                      <span v-for="h in horariosDia" :key="`${h.idHorario}-${h.idDia}`" 
                            style="background: #ffffff; border: 1px solid #e9ecef; border-radius: 3px; padding: 0.1rem 0.3rem; font-size: 0.7rem; color: #495057;">
                        {{ h.horaInicio }}-{{ h.horaFinal }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td class="acciones-cell">
            <div class="botones-acciones">
              <button @click="abrirModalEditar(taller)" class="btn-editar">
                Editar
              </button>
              <button @click="eliminarTaller(taller.id)" class="btn-eliminar">
                Eliminar
              </button>
              <button @click="abrirModalPagos(taller)" class="btn-pagos">
                Ver Pagos
              </button>
            </div>
          </td>
        </tr>
        <tr v-if="talleres.length === 0">
          <td colspan="5" style="text-align:center; padding: 2rem; color: #6c757d; font-style: italic;">No hay talleres registrados</td>
        </tr>
      </tbody>
      </table>
    </div>
    <div style="margin-top:1rem;">
      <button :disabled="page === 1" @click="cambiarPagina(page-1)">Anterior</button>
      Página {{ page }} de {{ totalPages }}
      <button :disabled="page === totalPages" @click="cambiarPagina(page+1)">Siguiente</button>
    </div>

    <!-- Modal Editar -->
    <div v-if="showModalEditar" class="modal">
      <div class="modal-content-compact">
        <div class="modal-header">
          <h3>📝 Editar Taller</h3>
          <button @click="cerrarModalEditar" class="btn-close-modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-grid">
            <label>Descripción
              <input v-model="tallerEditar.descripcion" />
            </label>
            <label>Maestro
              <select v-model="tallerEditar.idmaestro">
                <option value="">Selecciona un maestro</option>
                <option v-for="maestro in maestros" :key="maestro.Id" :value="maestro.Id">{{ maestro.Nombre }}</option>
              </select>
            </label>
            <label>Clases por Semana
              <input v-model.number="tallerEditar.clases" type="number" min="1" max="7" />
            </label>
          </div>
          
          <div class="grupos-section">
            <strong>Grupos del Taller:</strong>
            <div v-for="(grupo, grupoIndex) in tallerEditar.grupos" :key="grupoIndex" class="grupo-card">
              <div class="grupo-header">
                <h4 style="margin: 0; color: #495057; font-size: 1.1rem;">Grupo {{ grupoIndex + 1 }}</h4>
                <button v-if="tallerEditar.grupos.length > 1" @click="eliminarGrupoEditar(grupoIndex)" 
                        class="btn-eliminar-grupo">
                  Eliminar Grupo
                </button>
              </div>
              
              <div class="grupo-content">
                <div class="max-alumnos-section">
                  <label>Máximo de Alumnos
                    <input v-model.number="grupo.maxAlumnos" type="number" min="1" max="50" />
                  </label>
                </div>
                
                <div class="grados-section">
                  <strong>Grados por Nivel Académico:</strong>
                  <div class="niveles-container">
                    <div v-for="nivel in nivelesGrados" :key="nivel.idNivelAcademico" class="nivel-item">
                      <h5 class="nivel-title">{{ nivel.nivelAcademico }}</h5>
                      <div class="grados-grid">
                        <label v-for="grado in nivel.grados" :key="grado.id" 
                               class="grado-checkbox"
                               :class="{ 'selected-grado': grupo.grados.includes(grado.id) }">
                          <input type="checkbox" :value="grado.id" v-model="grupo.grados"/>
                          <span>{{ grado.grado }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="horarios-section">
                <strong>Horarios y Días para este grupo:</strong>
                <div class="dias-grid">
                  <div v-for="dia in dias" :key="dia.Id" class="dia-card">
                    <h5 class="dia-title">{{ dia.Dia }}</h5>
                    <div class="horarios-list">
                      <label v-for="horario in horariosDisponibles" :key="horario.id" 
                             class="horario-checkbox"
                             :class="{ 'selected-horario': tieneHorarioSeleccionadoGrupoEditar(horario.id, dia.Id, grupoIndex) }">
                        <input type="checkbox"
                          :checked="tieneHorarioSeleccionadoGrupoEditar(horario.id, dia.Id, grupoIndex)"
                          @change="toggleHorarioGrupoEditar(horario.id, dia.Id, grupoIndex, $event)"
                        />
                        <span>{{ horario.horaInicio }}-{{ horario.horaFinal }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <button @click="agregarGrupoEditar" class="btn-agregar-grupo">
              + Agregar Otro Grupo
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="cerrarModalEditar" class="btn-cancelar">Cancelar</button>
          <button @click="guardarEdicion" class="btn-guardar">Guardar</button>
        </div>
      </div>
    </div>

    <!-- Modal Agregar -->
    <div v-if="showModalAgregar" class="modal">
      <div class="modal-content-compact">
        <div class="modal-header">
          <h3>Agregar Taller</h3>
          <button @click="cerrarModalAgregar" class="btn-close-modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-grid">
            <label>Descripción
              <input v-model="tallerNuevo.descripcion" />
            </label>
            <label>Maestro
              <select v-model="tallerNuevo.idmaestro">
                <option value="">Selecciona un maestro</option>
                <option v-for="maestro in maestros" :key="maestro.Id" :value="maestro.Id">{{ maestro.Nombre }}</option>
              </select>
            </label>
            <label>Clases por Semana
              <input v-model="tallerNuevo.clases" type="number" min="1" max="7" />
            </label>
          </div>
          
          <div class="grupos-section">
            <strong>Grupos del Taller:</strong>
            <div v-for="(grupo, grupoIndex) in tallerNuevo.grupos" :key="grupoIndex" class="grupo-card">
              <div class="grupo-header">
                <h4 style="margin: 0; color: #495057; font-size: 1.1rem;">Grupo {{ grupoIndex + 1 }}</h4>
                <button v-if="tallerNuevo.grupos.length > 1" @click="eliminarGrupo(grupoIndex)" 
                        class="btn-eliminar-grupo">
                  Eliminar Grupo
                </button>
              </div>
              
              <div class="grupo-content">
                <div class="max-alumnos-section">
                  <label>Máximo de Alumnos
                    <input v-model.number="grupo.maxAlumnos" type="number" min="1" max="50" />
                  </label>
                </div>
                
                <div class="grados-section">
                  <strong>Grados por Nivel Académico:</strong>
                  <div class="niveles-container">
                    <div v-for="nivel in nivelesGrados" :key="nivel.idNivelAcademico" class="nivel-item">
                      <h5 class="nivel-title">{{ nivel.nivelAcademico }}</h5>
                      <div class="grados-grid">
                        <label v-for="grado in nivel.grados" :key="grado.id" 
                               class="grado-checkbox"
                               :class="{ 'selected-grado': grupo.grados.includes(grado.id) }">
                          <input type="checkbox" :value="grado.id" v-model="grupo.grados"/>
                          <span>{{ grado.grado }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="horarios-section">
                <strong>Horarios y Días para este grupo:</strong>
                <div class="dias-grid">
                  <div v-for="dia in dias" :key="dia.Id" class="dia-card">
                    <h5 class="dia-title">{{ dia.Dia }}</h5>
                    <div class="horarios-list">
                      <label v-for="horario in horariosDisponibles" :key="horario.id" 
                             class="horario-checkbox"
                             :class="{ 'selected-horario': tieneHorarioSeleccionadoGrupo(horario.id, dia.Id, grupoIndex) }">
                        <input type="checkbox"
                          :checked="tieneHorarioSeleccionadoGrupo(horario.id, dia.Id, grupoIndex)"
                          @change="toggleHorarioGrupo(horario.id, dia.Id, grupoIndex, $event)"
                        />
                        <span>{{ horario.horaInicio }}-{{ horario.horaFinal }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <button @click="agregarGrupo" class="btn-agregar-grupo">
              + Agregar Otro Grupo
            </button>
          </div>
        </div>
        
        <div class="modal-footer">
          <button @click="cerrarModalAgregar" class="btn-cancelar">Cancelar</button>
          <button @click="guardarNuevo" class="btn-agregar">Agregar</button>
        </div>
      </div>
    </div>

    <!-- Modal Pagos por Taller -->
    <div v-if="showModalPagos" class="modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000;">
      <div class="modal-content" style="background: white; border-radius: 8px; max-width: 1200px; width: 90%; max-height: 90vh; overflow-y: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.3);">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 1rem; border-bottom: 1px solid #e9ecef;">
          <h3 style="margin: 0; color: #495057;">💰 Pagos del Taller: {{ tallerSeleccionado && tallerSeleccionado.descripcion }}</h3>
          <button @click="cerrarModalPagos" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #6c757d;">&times;</button>
        </div>
        
        <div style="padding: 1rem;">
          <!-- Información del Taller -->
          <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
            <h4 style="margin: 0 0 0.5rem 0;">{{ tallerSeleccionado && tallerSeleccionado.descripcion }}</h4>
            <p style="margin: 0; opacity: 0.9;">
              Maestro: {{ tallerSeleccionado && tallerSeleccionado.nombreMaestro || 'No asignado' }} | 
              Total de alumnos: {{ pagosPorTaller && pagosPorTaller.total || 0 }}
            </p>
          </div>

          <!-- Cargando -->
          <div v-if="loadingPagosTaller" style="text-align: center; padding: 3rem;">
            <div style="color: #6c757d; font-size: 1.1rem;">
              <div style="margin-bottom: 1rem;">🔄 Cargando pagos del taller...</div>
              <div style="font-size: 0.9rem; opacity: 0.7;">Obteniendo información de pagos de los alumnos</div>
            </div>
          </div>

          <!-- Tabla de Pagos -->
          <div v-else-if="pagosPorTaller && pagosPorTaller.pagosAlumnos && pagosPorTaller.pagosAlumnos.length > 0">
            <div style="overflow-x: auto; max-height: 400px; overflow-y: auto; border: 1px solid #e9ecef; border-radius: 6px;">
              <table style="width: 100%; border-collapse: collapse; background: white;">
                <thead style="position: sticky; top: 0; z-index: 10;">
                  <tr style="background: linear-gradient(135deg, #fd7e14 0%, #f39c12 100%); color: white;">
                    <th style="padding: 0.8rem; text-align: left; border-bottom: 2px solid #e36d09;">Alumno</th>
                    <th style="padding: 0.8rem; text-align: center; border-bottom: 2px solid #e36d09;">Grado</th>
                    <th style="padding: 0.8rem; text-align: center; border-bottom: 2px solid #e36d09;">Último Pago</th>
                    <th style="padding: 0.8rem; text-align: center; border-bottom: 2px solid #e36d09;">Próximo Pago</th>
                    <th style="padding: 0.8rem; text-align: center; border-bottom: 2px solid #e36d09;">Estado</th>
                    <th style="padding: 0.8rem; text-align: center; border-bottom: 2px solid #e36d09;">Días</th>
                    <th style="padding: 0.8rem; text-align: center; border-bottom: 2px solid #e36d09;">Historial</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="alumno in pagosPorTaller.pagosAlumnos" :key="alumno.IdAlumno" style="border-bottom: 1px solid #e9ecef; background: white;">
                    <td style="padding: 0.8rem; font-weight: 600; background: white;">
                      {{ alumno.nombreAlumno }}
                    </td>
                    <td style="padding: 0.8rem; text-align: center; background: white;">
                      <span style="background: #e3f2fd; color: #1565c0; padding: 0.2rem 0.5rem; border-radius: 4px; font-size: 0.8rem; font-weight: 600;">
                        {{ alumno.nivelAcademico }} - {{ alumno.grado }}
                      </span>
                    </td>
                    <td style="padding: 0.8rem; text-align: center; background: white;">
                      <div v-if="alumno.ultimaFechaPago">
                        <div style="font-weight: 600; color: #28a745;">${{ alumno.cantidadPagadaUltimoPago || 0 }}</div>
                        <div style="font-size: 0.75rem; color: #6c757d;">{{ formatearFecha(alumno.ultimaFechaPago) }}</div>
                      </div>
                      <span v-else style="color: #dc3545; font-style: italic; font-size: 0.8rem;">Sin pagos</span>
                    </td>
                    <td style="padding: 0.8rem; text-align: center; font-size: 0.85rem; background: white;">
                      {{ formatearFecha(alumno.proximafechadepago) }}
                    </td>
                    <td style="padding: 0.8rem; text-align: center; background: white;">
                      <span :class="getEstadoClass(alumno.estadoPago)" style="padding: 0.2rem 0.5rem; border-radius: 4px; font-size: 0.75rem; font-weight: 600;">
                        {{ alumno.estadoPago }}
                      </span>
                    </td>
                    <td style="padding: 0.8rem; text-align: center; background: white;">
                      <span v-if="alumno.diasHastaVencimiento !== null" 
                            :style="alumno.diasHastaVencimiento < 0 ? 'color: #dc3545; font-weight: 600;' : alumno.diasHastaVencimiento <= 5 ? 'color: #fd7e14; font-weight: 600;' : 'color: #28a745;'">
                        {{ alumno.diasHastaVencimiento }}
                      </span>
                      <span v-else style="color: #6c757d;">--</span>
                    </td>
                    <td style="padding: 0.8rem; text-align: center; background: white;">
                      <button @click="verHistorialAlumno(alumno)" style="background: #17a2b8; color: white; border: none; padding: 0.3rem 0.6rem; border-radius: 3px; font-size: 0.75rem; cursor: pointer;">
                        Ver ({{ alumno.historialPagos && alumno.historialPagos.totalPagos || 0 }})
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginación -->
            <div style="margin-top: 1rem; text-align: center;" v-if="pagosPorTaller.total > pageSizeTaller">
              <button :disabled="pageTaller === 1" @click="cambiarPaginaTaller(pageTaller - 1)" style="margin: 0 0.5rem; padding: 0.3rem 0.8rem; border: 1px solid #ddd; background: white; cursor: pointer; border-radius: 4px;">
                ‹ Anterior
              </button>
              <span style="margin: 0 1rem; font-weight: 600;">
                Página {{ pageTaller }} de {{ Math.ceil(pagosPorTaller.total / pageSizeTaller) }}
              </span>
              <button :disabled="pageTaller >= Math.ceil(pagosPorTaller.total / pageSizeTaller)" @click="cambiarPaginaTaller(pageTaller + 1)" style="margin: 0 0.5rem; padding: 0.3rem 0.8rem; border: 1px solid #ddd; background: white; cursor: pointer; border-radius: 4px;">
                Siguiente ›
              </button>
            </div>
          </div>

          <!-- Sin datos -->
          <div v-else-if="!loadingPagosTaller" style="text-align: center; padding: 3rem; color: #6c757d; background: white; border-radius: 6px; border: 1px solid #e9ecef;">
            <div style="font-size: 1.2rem; margin-bottom: 0.5rem;">📊</div>
            <div>No hay alumnos registrados en este taller</div>
          </div>

          <!-- Footer del modal -->
          <div style="margin-top: 2rem; text-align: right; border-top: 1px solid #e9ecef; padding-top: 1rem;">
            <button @click="cerrarModalPagos" style="background: #6c757d; color: white; border: none; padding: 0.6rem 1.2rem; border-radius: 4px; cursor: pointer;">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Historial Individual -->
    <div v-if="showModalHistorial" class="modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1001;">
      <div class="modal-content" style="background: white; border-radius: 8px; max-width: 800px; width: 90%; max-height: 90vh; overflow-y: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.3);">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 1rem; border-bottom: 1px solid #e9ecef;">
          <h3 style="margin: 0; color: #495057;">📋 Historial de Pagos</h3>
          <button @click="cerrarModalHistorial" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #6c757d;">&times;</button>
        </div>
        
        <div style="padding: 1rem;">
          <div style="background: #f8f9fa; padding: 1rem; border-radius: 6px; margin-bottom: 1rem;">
            <h4 style="margin: 0 0 0.5rem 0; color: #495057;">{{ alumnoSeleccionado && alumnoSeleccionado.nombreAlumno }}</h4>
            <p style="margin: 0; color: #6c757d; font-size: 0.9rem;">
              {{ alumnoSeleccionado && alumnoSeleccionado.nivelAcademico }} - {{ alumnoSeleccionado && alumnoSeleccionado.grado }}
            </p>
          </div>

          <div style="overflow-x: auto; max-height: 300px; overflow-y: auto; border: 1px solid #e9ecef; border-radius: 6px;">
            <table style="width: 100%; border-collapse: collapse; background: white;">
              <thead style="position: sticky; top: 0; background: #e9ecef;">
                <tr>
                  <th style="padding: 0.8rem; border: 1px solid #dee2e6;">Folio</th>
                  <th style="padding: 0.8rem; border: 1px solid #dee2e6;">Fecha Pago</th>
                  <th style="padding: 0.8rem; border: 1px solid #dee2e6;">Cantidad</th>
                  <th style="padding: 0.8rem; border: 1px solid #dee2e6;">Próximo Pago</th>
                  <th style="padding: 0.8rem; border: 1px solid #dee2e6;">Tipo/Forma</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pago in alumnoSeleccionado && alumnoSeleccionado.historialPagos && alumnoSeleccionado.historialPagos.pagos" :key="pago.id" style="background: white;">
                  <td style="padding: 0.6rem; border: 1px solid #dee2e6; text-align: center; font-weight: 600; background: white;">#{{ pago.folio }}</td>
                  <td style="padding: 0.6rem; border: 1px solid #dee2e6; background: white;">{{ formatearFecha(pago.fechadepago) }}</td>
                  <td style="padding: 0.6rem; border: 1px solid #dee2e6; text-align: right; font-weight: 600; color: #28a745; background: white;">${{ pago.cantidadpagada || 0 }}</td>
                  <td style="padding: 0.6rem; border: 1px solid #dee2e6; background: white;">{{ formatearFecha(pago.proximafechadepago) }}</td>
                  <td style="padding: 0.6rem; border: 1px solid #dee2e6; font-size: 0.8rem; background: white;">
                    <div>{{ pago.tipoDepago || 'Sin tipo' }}</div>
                    <div style="color: #6c757d;">{{ pago.formaDePago || 'Sin forma' }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style="margin-top: 1rem; text-align: right;">
            <button @click="cerrarModalHistorial" style="background: #6c757d; color: white; border: none; padding: 0.5rem 1rem; border-radius: 4px; cursor: pointer;">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetch } from '../restapi.js';

export default {
  name: 'TalleresView',
  data() {
    return {
      talleres: [],
      total: 0,
      page: 1,
      pageSize: 10,
      filtroDescripcion: '',
      busquedaTimeout: null,
      showModalEditar: false,
      showModalAgregar: false,
      tallerEditar: null,
      tallerNuevo: {
        descripcion: '',
        idmaestro: '',
        clases: 1,
        grupos: [
          {
            maxAlumnos: 10,
            grados: [],
            horariosDias: []
          }
        ]
      },
      dias: [],
      horariosDisponibles: [],
      maestros: [],
      nivelesGrados: [], // Niveles académicos con sus grados
      // Variables para modal de pagos
      showModalPagos: false,
      tallerSeleccionado: null,
      pagosPorTaller: null,
      pageTaller: 1,
      pageSizeTaller: 10,
      loadingPagosTaller: false,
      showModalHistorial: false,
      alumnoSeleccionado: null
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    }
  },
  methods: {
    async getErrorMessage(response) {
      try {
        const errorData = await response.json();
        return errorData.message || 'Error desconocido';
      } catch (e) {
        return 'Error desconocido';
      }
    },
    async fetchTalleres(descripcion = '') {
      let params = `?page=${this.page}&pageSize=${this.pageSize}`;
      if (descripcion.trim()) {
        params += `&descripcion=${encodeURIComponent(descripcion.trim())}`;
      }
      
      try {
        const response = await apiFetch(`/talleres/ObtenerTalleresPaginado${params}`, {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();
        this.talleres = data.talleres || [];
        this.total = data.total || 0;
      } catch (err) {
        this.talleres = [];
        this.total = 0;
        if (this.$toast) this.$toast.error(err.message || 'Error al obtener talleres');
      }
    },
    async fetchDias() {
      try {
        const response = await apiFetch('/dias/ObtenerListaDias', {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        this.dias = await response.json();
      } catch (err) {
        this.dias = [];
      }
    },
    async fetchHorariosDisponibles() {
      try {
        const response = await apiFetch('/horarios/ObtenerHorariosPaginado?page=1&pageSize=100', {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();
        this.horariosDisponibles = data.horarios || [];
      } catch (err) {
        this.horariosDisponibles = [];
      }
    },
    async fetchMaestros() {
      try {
        const response = await apiFetch('/usuarios/ObtenerListaUsuarios', {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        this.maestros = await response.json();
      } catch (err) {
        this.maestros = [];
        if (this.$toast) this.$toast.error(err.message || 'Error al obtener maestros');
      }
    },
    async fetchNivelesGrados() {
      try {
        console.log('Iniciando fetchNivelesGrados...');
        const response = await apiFetch('/nivelyGrados/ObtenerListaGradosAgrupados', {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('Datos recibidos de nivelesGrados:', data);
        
        if (Array.isArray(data)) {
          this.nivelesGrados = data;
          console.log('nivelesGrados asignado correctamente:', this.nivelesGrados.length, 'niveles');
        } else {
          console.warn('Los datos recibidos no son un array:', data);
          this.nivelesGrados = [];
        }
      } catch (err) {
        console.error('Error en fetchNivelesGrados:', err);
        this.nivelesGrados = [];
        if (this.$toast) this.$toast.error(err.message || 'Error al obtener niveles y grados');
      }
    },
    agruparHorariosPorDiaGrupo(horariosDias) {
      const agrupados = {};
      if (!horariosDias) return agrupados;
      horariosDias.forEach(h => {
        if (!agrupados[h.Dia]) agrupados[h.Dia] = [];
        agrupados[h.Dia].push(h);
      });
      return agrupados;
    },
    async abrirModalEditar(taller) {
      console.log('Abriendo modal editar...', taller);
      
      // Asegurar que tenemos los datos necesarios
      if (!this.nivelesGrados || this.nivelesGrados.length === 0) {
        console.log('Cargando niveles y grados para edición...');
        await this.fetchNivelesGrados();
      }
      
      if (!this.maestros || this.maestros.length === 0) {
        console.log('Cargando maestros para edición...');
        await this.fetchMaestros();
      }
      
      this.tallerEditar = {
        id: taller.id,
        descripcion: taller.descripcion,
        idmaestro: taller.idmaestro,
        clases: taller.clases || 1,
        grupos: (taller.grupos || []).map(grupo => ({
          idGrupo: grupo.idGrupo,
          maxAlumnos: grupo.maxAlumnos,
          grados: grupo.grados.map(g => g.idGrado),
          horariosDias: grupo.horariosDias.map(h => ({ idHorario: h.idHorario, idDia: h.idDia }))
        }))
      };
      this.showModalEditar = true;
      console.log('Modal editar abierto, nivelesGrados:', this.nivelesGrados.length);
    },
    cerrarModalEditar() {
      this.showModalEditar = false;
      this.tallerEditar = null;
    },
    tieneHorarioSeleccionadoGrupoEditar(idHorario, idDia, grupoIndex) {
      if (!this.tallerEditar || !this.tallerEditar.grupos[grupoIndex]) return false;
      return this.tallerEditar.grupos[grupoIndex].horariosDias.some(h => h.idHorario === idHorario && h.idDia === idDia);
    },
    toggleHorarioGrupoEditar(idHorario, idDia, grupoIndex, event) {
      if (!this.tallerEditar || !this.tallerEditar.grupos[grupoIndex]) return;
      const horariosDias = this.tallerEditar.grupos[grupoIndex].horariosDias;
      const idx = horariosDias.findIndex(h => h.idHorario === idHorario && h.idDia === idDia);
      
      if (event.target.checked && idx === -1) {
        horariosDias.push({ idHorario, idDia });
      } else if (!event.target.checked && idx !== -1) {
        horariosDias.splice(idx, 1);
      }
    },
    agregarGrupoEditar() {
      this.tallerEditar.grupos.push({
        maxAlumnos: 10,
        grados: [],
        horariosDias: []
      });
    },
    eliminarGrupoEditar(index) {
      this.tallerEditar.grupos.splice(index, 1);
    },
    async guardarEdicion() {
      if (!this.tallerEditar) return;
      try {
        // Validar que al menos un grupo tenga horarios
        const gruposValidos = this.tallerEditar.grupos.filter(g => g.horariosDias.length > 0 && g.grados.length > 0);
        if (gruposValidos.length === 0) {
          if (this.$toast) this.$toast.error('Cada grupo debe tener al menos un horario y un grado seleccionado');
          return;
        }

        const response = await apiFetch(`/talleres/ModificarTaller/${this.tallerEditar.id}`, {
          method: 'PATCH',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            descripcion: this.tallerEditar.descripcion,
            idmaestro: parseInt(this.tallerEditar.idmaestro),
            clases: parseInt(this.tallerEditar.clases),
            grupos: gruposValidos.map(grupo => ({
              idGrupo: grupo.idGrupo,
              maxAlumnos: grupo.maxAlumnos,
              grados: grupo.grados,
              horariosDias: grupo.horariosDias
            }))
          })
        });
        if (!response.ok) {
          const errorMessage = await this.getErrorMessage(response);
          throw new Error(errorMessage);
        }
        const data = await response.json();
        this.cerrarModalEditar();
        this.fetchTalleres(this.filtroDescripcion);
        if (this.$toast) this.$toast.success(data.message || 'Taller editado correctamente');
      } catch (err) {
        if (this.$toast) this.$toast.error(err.message);
      }
    },
    async abrirModalAgregar() {
      console.log('Abriendo modal agregar...');
      
      // Asegurar que tenemos los datos necesarios
      if (!this.nivelesGrados || this.nivelesGrados.length === 0) {
        console.log('Cargando niveles y grados...');
        await this.fetchNivelesGrados();
      }
      
      if (!this.maestros || this.maestros.length === 0) {
        console.log('Cargando maestros...');
        await this.fetchMaestros();
      }
      
      this.tallerNuevo = { 
        descripcion: '', 
        idmaestro: '', 
        clases: 1,
        grupos: [
          {
            maxAlumnos: 10,
            grados: [],
            horariosDias: []
          }
        ]
      };
      this.showModalAgregar = true;
      console.log('Modal agregar abierto, nivelesGrados:', this.nivelesGrados.length);
    },
    cerrarModalAgregar() {
      this.showModalAgregar = false;
    },
    tieneHorarioSeleccionadoGrupo(idHorario, idDia, grupoIndex) {
      if (!this.tallerNuevo || !this.tallerNuevo.grupos[grupoIndex]) return false;
      return this.tallerNuevo.grupos[grupoIndex].horariosDias.some(h => h.idHorario === idHorario && h.idDia === idDia);
    },
    toggleHorarioGrupo(idHorario, idDia, grupoIndex, event) {
      if (!this.tallerNuevo || !this.tallerNuevo.grupos[grupoIndex]) return;
      const horariosDias = this.tallerNuevo.grupos[grupoIndex].horariosDias;
      const idx = horariosDias.findIndex(h => h.idHorario === idHorario && h.idDia === idDia);
      
      if (event.target.checked && idx === -1) {
        horariosDias.push({ idHorario, idDia });
      } else if (!event.target.checked && idx !== -1) {
        horariosDias.splice(idx, 1);
      }
    },
    agregarGrupo() {
      this.tallerNuevo.grupos.push({
        maxAlumnos: 10,
        grados: [],
        horariosDias: []
      });
    },
    eliminarGrupo(index) {
      this.tallerNuevo.grupos.splice(index, 1);
    },
    async guardarNuevo() {
      try {
        // Validar que al menos un grupo tenga horarios
        const gruposValidos = this.tallerNuevo.grupos.filter(g => g.horariosDias.length > 0 && g.grados.length > 0);
        if (gruposValidos.length === 0) {
          if (this.$toast) this.$toast.error('Cada grupo debe tener al menos un horario y un grado seleccionado');
          return;
        }

        const response = await apiFetch('/talleres/AgregarTaller', {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            descripcion: this.tallerNuevo.descripcion,
            idmaestro: parseInt(this.tallerNuevo.idmaestro),
            clases: parseInt(this.tallerNuevo.clases),
            grupos: gruposValidos
          })
        });
        if (!response.ok) {
          const errorMessage = await this.getErrorMessage(response);
          throw new Error(errorMessage);
        }
        const data = await response.json();
        this.cerrarModalAgregar();
        this.fetchTalleres(this.filtroDescripcion);
        if (this.$toast) this.$toast.success(data.message || 'Taller agregado correctamente');
      } catch (err) {
        if (this.$toast) this.$toast.error(err.message);
      }
    },
    async eliminarTaller(id) {
      if (confirm('¿Seguro que deseas eliminar este taller?')) {
        try {
          const response = await apiFetch(`/talleres/EliminarTaller/${id}`, {
            method: 'DELETE',
            headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          if (!response.ok) {
            const errorMessage = await this.getErrorMessage(response);
            throw new Error(errorMessage);
          }
          const data = await response.json();
          this.fetchTalleres(this.filtroDescripcion);
          if (this.$toast) this.$toast.success(data.message || 'Taller eliminado correctamente');
        } catch (err) {
          if (this.$toast) this.$toast.error(err.message);
        }
      }
    },
    aplicarFiltros() {
      // Realizar búsqueda directa en la API
      this.page = 1; // Resetear a la primera página
      this.fetchTalleres(this.filtroDescripcion);
    },
    buscarEnTiempoReal() {
      // Limpiar el timeout anterior si existe
      if (this.busquedaTimeout) {
        clearTimeout(this.busquedaTimeout);
      }
      
      // Establecer un nuevo timeout para hacer la búsqueda después de 500ms
      this.busquedaTimeout = setTimeout(() => {
        this.page = 1; // Resetear a la primera página
        this.fetchTalleres(this.filtroDescripcion);
      }, 500);
    },
    cambiarPagina(nuevaPagina) {
      this.page = nuevaPagina;
      this.fetchTalleres(this.filtroDescripcion);
    },

    // Métodos para modal de pagos
    async abrirModalPagos(taller) {
      this.tallerSeleccionado = taller;
      this.showModalPagos = true;
      this.loadingPagosTaller = true;
      this.pageTaller = 1;
      
      try {
        await this.cargarPagosPorTaller();
      } catch (error) {
        console.error('Error al cargar pagos:', error);
        if (this.$toast) {
          this.$toast.error('Error al cargar los pagos del taller');
        }
      } finally {
        this.loadingPagosTaller = false;
      }
    },

    async cargarPagosPorTaller() {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`http://51.83.46.40:3000/api/pagos/ObtenerPagosAlumnosPorTaller/${this.tallerSeleccionado.id}?page=${this.pageTaller}&pageSize=${this.pageSizeTaller}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error('Error al obtener los pagos por taller');
        }

        const data = await response.json();
        this.pagosPorTaller = data;
        console.log('Pagos por taller cargados:', data);
      } catch (error) {
        console.error('Error al cargar pagos por taller:', error);
        throw error;
      }
    },

    async cambiarPaginaTaller(nuevaPagina) {
      if (nuevaPagina < 1) return;
      const maxPaginas = Math.ceil(this.pagosPorTaller.total / this.pageSizeTaller);
      if (nuevaPagina > maxPaginas) return;
      
      this.pageTaller = nuevaPagina;
      this.loadingPagosTaller = true;
      
      try {
        await this.cargarPagosPorTaller();
      } catch (error) {
        console.error('Error al cambiar página:', error);
        if (this.$toast) {
          this.$toast.error('Error al cargar la página');
        }
      } finally {
        this.loadingPagosTaller = false;
      }
    },

    cerrarModalPagos() {
      this.showModalPagos = false;
      this.tallerSeleccionado = null;
      this.pagosPorTaller = null;
      this.pageTaller = 1;
    },

    verHistorialAlumno(alumno) {
      this.alumnoSeleccionado = alumno;
      this.showModalHistorial = true;
    },

    cerrarModalHistorial() {
      this.showModalHistorial = false;
      this.alumnoSeleccionado = null;
    },

    formatearFecha(fecha) {
      if (!fecha) return 'N/A';
      const fechaObj = new Date(fecha);
      return fechaObj.toLocaleDateString('es-MX');
    },

    getEstadoClass(estado) {
      if (!estado) return 'estado-desconocido';
      
      switch (estado.toLowerCase()) {
        case 'al día':
        case 'al dia':
        case 'pagado':
          return 'estado-al-dia';
        case 'atrasado':
        case 'vencido':
          return 'estado-vencido';
        case 'próximo vencimiento':
        case 'proximo vencimiento':
          return 'estado-proximo';
        default:
          return 'estado-desconocido';
      }
    }
  },
  mounted() {
    this.fetchTalleres(this.filtroDescripcion);
    this.fetchDias();
    this.fetchHorariosDisponibles();
    this.fetchMaestros();
    this.fetchNivelesGrados();
    // Configurar scroll horizontal
    this.$nextTick(() => {
      const tabla = document.querySelector('.tabla-responsive');
      if (tabla) {
        // Scroll con rueda del mouse
        tabla.addEventListener('wheel', (e) => {
          if (tabla.scrollWidth > tabla.clientWidth) {
            e.preventDefault();
            tabla.scrollLeft += e.deltaY;
          }
        }, { passive: false });
        
        // Variables para arrastrar
        let isDown = false;
        let startX;
        let scrollLeft;
        
        // Eventos de mouse para arrastrar
        tabla.addEventListener('mousedown', (e) => {
          isDown = true;
          tabla.classList.add('active');
          startX = e.pageX - tabla.offsetLeft;
          scrollLeft = tabla.scrollLeft;
          tabla.style.cursor = 'grabbing';
        });
        
        tabla.addEventListener('mouseleave', () => {
          isDown = false;
          tabla.classList.remove('active');
          tabla.style.cursor = 'grab';
        });
        
        tabla.addEventListener('mouseup', () => {
          isDown = false;
          tabla.classList.remove('active');
          tabla.style.cursor = 'grab';
        });
        
        tabla.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - tabla.offsetLeft;
          const walk = (x - startX) * 2;
          tabla.scrollLeft = scrollLeft - walk;
        });
      }
    });
  },
  beforeDestroy() {
    // Limpiar el timeout para evitar memory leaks
    if (this.busquedaTimeout) {
      clearTimeout(this.busquedaTimeout);
    }
  }
};
</script>

<style scoped>
/* --- TABLA RESPONSIVA --- */
.tabla-responsive {
  width: 100% !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-radius: 8px;
  max-width: 100vw !important;
  display: block !important;
  position: relative;
  scrollbar-width: auto;
  scrollbar-color: #4a90e2 #e0e0e0;
  cursor: grab;
}
.tabla-responsive:active { cursor: grabbing; }
.tabla-responsive::-webkit-scrollbar { height: 12px; }
.tabla-responsive::-webkit-scrollbar-track { background: #e0e0e0; border-radius: 6px; }
.tabla-responsive::-webkit-scrollbar-thumb {
  background: #4a90e2;
  border-radius: 6px;
  border: 2px solid #e0e0e0;
}
.tabla-responsive::-webkit-scrollbar-thumb:hover { background: #357abd; }
.tabla-responsive::after {
  content: "← Desplázate horizontalmente →";
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #666;
  opacity: 0.7;
  pointer-events: none;
}
@media (min-width: 1201px) { .tabla-responsive::after { display: none; } }
.tabla-talleres-principal {
  width: 1100px !important;
  border-collapse: collapse;
  min-width: 1100px !important;
  max-width: none !important;
  border-radius: 8px;
  overflow: visible;
  background: #fff;
  margin: 0;
  table-layout: fixed !important;
  display: table !important;
}
.tabla-talleres-principal th,
.tabla-talleres-principal td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tabla-talleres-principal th:nth-child(4),
.tabla-talleres-principal td:nth-child(4) {
  white-space: normal;
  word-wrap: break-word;
}

/* --- ESTILOS RESPONSIVE PARA BOTONES DE ACCIONES --- */
.acciones-cell {
  padding: 0.8rem !important;
  text-align: center !important;
  white-space: nowrap !important;
  min-width: 160px !important;
}

.botones-acciones {
  display: flex !important;
  gap: 0.5rem !important;
  justify-content: center !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
}

.btn-editar,
.btn-eliminar {
  padding: 0.4rem 0.8rem !important;
  border: none !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  white-space: nowrap !important;
  min-width: 70px !important;
  text-align: center !important;
}

.btn-editar {
  background: #28a745 !important;
  color: white !important;
}

.btn-editar:hover {
  background: #218838 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3) !important;
}

.btn-eliminar {
  background: #dc3545 !important;
  color: white !important;
}

.btn-eliminar:hover {
  background: #c82333 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3) !important;
}

.btn-pagos {
  background: #fd7e14 !important;
  color: white !important;
  padding: 0.4rem 0.8rem !important;
  border: none !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  white-space: nowrap !important;
  min-width: 70px !important;
  text-align: center !important;
}

.btn-pagos:hover {
  background: #e36d09 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 4px rgba(253, 126, 20, 0.3) !important;
}

/* Estados de pago */
.estado-al-dia {
  background-color: #28a745 !important;
  color: white !important;
}

.estado-vencido {
  background-color: #dc3545 !important;
  color: white !important;
}

.estado-proximo {
  background-color: #fd7e14 !important;
  color: white !important;
}

.estado-desconocido {
  background-color: #6c757d !important;
  color: white !important;
}

/* Responsive para pantallas pequeñas */
@media (max-width: 768px) {
  .botones-acciones {
    flex-direction: column !important;
    gap: 0.3rem !important;
  }
  
  .btn-editar,
  .btn-eliminar,
  .btn-pagos {
    width: 100% !important;
    min-width: 80px !important;
    font-size: 0.8rem !important;
    padding: 0.3rem 0.6rem !important;
  }
  
  .acciones-cell {
    min-width: 90px !important;
  }
}

/* Para pantallas muy pequeñas */
@media (max-width: 480px) {
  .btn-editar,
  .btn-eliminar,
  .btn-pagos {
    font-size: 0.75rem !important;
    padding: 0.25rem 0.4rem !important;
  }
  
  .botones-acciones {
    gap: 0.2rem !important;
  }
}
.modal {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content-compact {
  background: #fff !important;
  border-radius: 12px !important;
  width: 90vw !important;
  max-width: 800px !important;
  max-height: 90vh !important;
  box-shadow: 0 20px 40px rgba(0,0,0,0.3) !important;
  display: flex !important;
  flex-direction: column !important;
  position: relative !important;
  margin: auto !important;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 1.5rem;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
}

.btn-close-modal {
  background: none;
  border: none;
  color: white;
  font-size: 1.8rem;
  font-weight: bold;
  cursor: pointer;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  line-height: 1;
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.2);
}

.modal-body {
  padding: 1.2rem !important;
  overflow-y: auto !important;
  flex: 1 !important;
  max-height: calc(90vh - 140px) !important;
  scrollbar-width: thin !important;
  scrollbar-color: #cbd5e0 #f7fafc !important;
}

.modal-body::-webkit-scrollbar {
  width: 6px;
}

.modal-body::-webkit-scrollbar-track {
  background: #f7fafc;
  border-radius: 3px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 3px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.btn-cancelar {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-cancelar:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.btn-guardar, .btn-agregar {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  padding: 0.6rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);
}

.btn-guardar:hover, .btn-agregar:hover {
  background: linear-gradient(135deg, #218838, #1ea085);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

.modal-content-compact label {
  display: block;
  margin-top: 0.8rem;
  font-weight: 500;
  color: #495057;
}

.modal-content-compact input,
.modal-content-compact select {
  width: 100%;
  padding: 0.5rem;
  margin-top: 0.3rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: border-color 0.2s ease;
}

.modal-content-compact input:focus,
.modal-content-compact select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.form-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 1rem !important;
  margin-bottom: 1.5rem !important;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

.form-grid label {
  margin-bottom: 0.5rem;
}

.grupos-section {
  margin-top: 1.5rem;
}

.grupos-section > strong {
  display: block;
  margin-bottom: 1rem;
  color: #495057;
  font-size: 1.1rem;
}

.grupo-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  margin: 1rem 0;
  padding: 1.2rem;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  transition: box-shadow 0.2s ease;
}

.grupo-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.grupo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #e9ecef;
}

.btn-eliminar-grupo {
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.2s ease;
}

.btn-eliminar-grupo:hover {
  background: #c82333;
  transform: translateY(-1px);
}

.grupo-content {
  display: grid !important;
  grid-template-columns: 300px 1fr !important;
  gap: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

@media (max-width: 768px) {
  .grupo-content {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

.max-alumnos-section label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #495057;
}

.grados-section > strong {
  display: block;
  margin-bottom: 0.8rem;
  color: #495057;
  font-weight: 600;
}

.niveles-container {
  max-height: 200px;
  overflow-y: auto;
  padding-right: 0.5rem;
}

.nivel-item {
  margin-bottom: 1rem;
}

.nivel-title {
  margin: 0 0 0.5rem 0;
  color: #6c757d;
  font-size: 0.9rem;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.3rem;
  font-weight: 500;
}

.grados-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.grado-checkbox {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  padding: 0.3rem 0.6rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: all 0.2s ease;
  user-select: none;
}

.grado-checkbox:hover {
  background: #e9ecef;
}

.grado-checkbox.selected-grado {
  background: #d4edda;
  border-color: #28a745;
  color: #155724;
}

.grado-checkbox input {
  margin-right: 0.4rem;
}

.horarios-section > strong {
  display: block;
  margin-bottom: 0.8rem;
  color: #495057;
  font-weight: 600;
}

.dias-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 1rem;
}

.dia-card {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 0.8rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.dia-title {
  margin: 0 0 0.6rem 0;
  color: #495057;
  text-align: center;
  font-size: 0.9rem;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.4rem;
  font-weight: 600;
}

.horarios-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.horario-checkbox {
  display: flex;
  align-items: center;
  padding: 0.3rem 0.5rem;
  background: #f8f9fa;
  border-radius: 3px;
  border: 1px solid #e9ecef;
  cursor: pointer;
  font-size: 0.8rem;
  transition: all 0.2s ease;
  user-select: none;
}

.horario-checkbox:hover {
  background: #e9ecef;
}

.horario-checkbox.selected-horario {
  background: #d1ecf1;
  border-color: #17a2b8;
  color: #0c5460;
}

.horario-checkbox input {
  margin-right: 0.4rem;
}

.btn-agregar-grupo {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.7rem 1.2rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  margin: 1rem 0;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);
}

.btn-agregar-grupo:hover {
  background: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

.grupo-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.btn-add-group {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.6rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 0.5rem;
  transition: background-color 0.2s ease;
}

.btn-add-group:hover {
  background: #0056b3;
}

.btn-delete-group {
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: background-color 0.2s ease;
}

.btn-delete-group:hover {
  background: #c82333;
}
.selected-horario {
  background: #e3f2fd !important;
  border-color: #2196f3 !important;
  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.2);
}
.selected-grado {
  background: #e8f5e8 !important;
  border-color: #28a745 !important;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);
}
</style>
